import { DocumentState } from '../../common';

export type PayoutState =
  | DocumentState.AGREEMENT_DRAFT
  | DocumentState.DRAFT
  | DocumentState.REVIEW_MISSING_DATA
  | DocumentState.REVIEW_READY_TO_SEND
  | DocumentState.SENT
  | DocumentState.SENT_FAILED
  | DocumentState.LATE
  | DocumentState.PAID
  | DocumentState.PAYMENT_FAILED
  | DocumentState.CANCELED;

export const PayoutLockingStates = [
  DocumentState.SENT,
  DocumentState.SENT_FAILED,
  DocumentState.LATE,
  DocumentState.PAID,
  DocumentState.PAYMENT_FAILED,
] as const;
